export const BottomRightHandleStyles: React.CSSProperties = {
  position: 'absolute',
  width: '20px',
  height: '20px',
  zIndex: 1,
  bottom: 0,
  right: 0,
}

export const BottomHandleStyles: React.CSSProperties = {
  position: 'relative',
  width: '100%',
  height: 20,
  left: 0,
  bottom: 0,
  cursor: 'default',
}
